import { render, staticRenderFns } from "./CodeBlock.vue?vue&type=template&id=c330c8cc&scoped=true"
import script from "./CodeBlock.vue?vue&type=script&lang=js"
export * from "./CodeBlock.vue?vue&type=script&lang=js"
import style0 from "./CodeBlock.vue?vue&type=style&index=0&id=c330c8cc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c330c8cc",
  null
  
)

export default component.exports